// Выбор ферм к обмену снабжения на монеты по аграризму — ПО ИГРОКАМ:
// {byPlayerId: {[playerId]: {isAgrarianismConversionOn, selectedFarmsForConversion}}}.
// В одновременной фазе снабжения сетевой игры выбирают все разом, и общий на
// партию выбор смешивал бы фермы разных игроков. Игрока в payload.playerId
// подставляет обертка sharedStateReducer (для старых записей матчей без
// playerId — текущего игрока). Читать — через селекторы
// selectIsAgrarianismConversionOn / selectSelectedFarmsForConversion
const initialState = {
  byPlayerId: {},
};

const EMPTY_PLAYER_SELECTION = {
  isAgrarianismConversionOn: false,
  selectedFarmsForConversion: [],
};

// Состояние прежней формы (общий на партию выбор) читается как пустое
const getByPlayerId = (state) => state?.byPlayerId || {};

const withoutPlayer = (state, playerId) => {
  const byPlayerId = getByPlayerId(state);
  if (!playerId || !byPlayerId[playerId]) {
    return state;
  }
  const {[playerId]: _removed, ...rest} = byPlayerId;
  return {...state, byPlayerId: rest};
};

const updatePlayer = (state, playerId, update) => {
  if (!playerId) {
    return state;
  }
  const byPlayerId = getByPlayerId(state);
  const current = byPlayerId[playerId] || EMPTY_PLAYER_SELECTION;
  return {
    ...state,
    byPlayerId: {
      ...byPlayerId,
      [playerId]: {...current, ...update(current)},
    },
  };
};

const policyAgrarianismReducer = (state = initialState, action) => {
  const playerId = action.payload?.playerId;
  switch (action.type) {
    case 'POLICY_AGRARIANISM_SWITCH_CONVERSION_ON':
      return updatePlayer(state, playerId, () => ({isAgrarianismConversionOn: true}));
    // Выключение обмена, сам обмен и завершение игроком своей части
    // одновременной фазы снабжения сбрасывают выбор только этого игрока
    case 'POLICY_AGRARIANISM_SWITCH_CONVERSION_OFF':
    case 'POLICY_AGRARIANISM_COMMIT_CONVERSION':
    case 'COMPLETE_PLAYER_SUPPLY':
      return withoutPlayer(state, playerId);
    // Конец хода (или закрытие одновременной фазы снабжения) — выбор сбрасывается у всех
    case 'COMPLETE_PHASE':
      return Object.keys(getByPlayerId(state)).length === 0 ? state : initialState;
    case 'POLICY_AGRARIANISM_SELECT_FARM_FOR_CONVERSION': {
      const {farmHexKey} = action.payload;
      return updatePlayer(state, playerId, (current) => ({
        selectedFarmsForConversion: [...current.selectedFarmsForConversion, farmHexKey],
      }));
    }
    default:
      return state;
  }
};

export const selectPlayerAgrarianismSelection = (policyAgrarianismState, playerId) => (
  policyAgrarianismState?.byPlayerId?.[playerId] || EMPTY_PLAYER_SELECTION
);

export default policyAgrarianismReducer;
